import { useLocation } from 'react-router-dom';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectFilesSidebarOpen, selectWorkspaceSidebarOpen, selectFocusModeEnabled, selectTrialMode } from 'app/store/AppUI/AppUI.selectors';
// Mui
import { Box, Paper, Theme } from '@mui/material';
// Constants
import { SIDEBAR_WIDTH } from 'app/App.constants';
// 
import BatchesFilter from './BatchesFilter';
import CollectionSelect from './CollectionSelect';
import BatchesList from './BatchesList';
import CollectionTotalPages from './CollectionTotalPages';
import SidebarToggle from './SidebarToggle';
import DocumentsPreference from './DocumentsPreference';

const DocumentsSidebar = () => {
  const { pathname } = useLocation<{ pathname:string }>();
  const isWorkspacePath = pathname.includes('workspace');

  // State
  const filesSidebarOpen = useAppSelector(selectFilesSidebarOpen);
  const workspaceSidebarOpen = useAppSelector(selectWorkspaceSidebarOpen);
  const trialMode = useAppSelector(selectTrialMode);
  const focusModeEnabled = useAppSelector(selectFocusModeEnabled);

  const open = isWorkspacePath ? workspaceSidebarOpen : filesSidebarOpen;

  const hideForDocumentPage = /\/documents\/\d+\/\d+/.test(pathname);

  if ( trialMode || focusModeEnabled || hideForDocumentPage ) return null;
  return (
    <Paper
      sx={{
        borderTop: 0,
        borderLeft: 0,
        borderBottom: 0,
        width: SIDEBAR_WIDTH,
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        position: 'relative',
        marginLeft: open ? 0 : `-${SIDEBAR_WIDTH}px`
      }}
      square
    >
      <BatchesFilter />
      <Box sx={{
        display: 'flex', alignItems: 'center', gap: 2,
        borderBottom: (theme:Theme) => `1px solid ${theme.palette.divider}`,
        px: 4, mb: 4
      }}>
        <CollectionSelect />
        <DocumentsPreference />
      </Box>
      <BatchesList />
      <CollectionTotalPages />
      <SidebarToggle />
    </Paper>
  )
}

export default DocumentsSidebar;
